import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const processConfirm = (state: State = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROCESS_CONFIRM_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_PROCESS_CONFIRM_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_PROCESS_CONFIRM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.CLEAR_PROCESS_CONFIRM_DATA:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: {}
      }
    default:
      return state;
  }
}
